import useGames from '../../lib/hooks/useGames';
import { Layout } from '../../components';
import { useEffect, useState } from 'react';
import { Tabs, TabsProps } from 'antd';
import CardsTable from './ui/CardsTable';

const GameCardsPage = ({ logOut }: { logOut: () => void }) => {
  const { onGetGamesCard } = useGames();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    onGetGamesCard();
    setLoading(false);
  }, []);

  const onChangeTab = (key: string) => {
    console.log(key);
  };

  const items: TabsProps['items'] = [
    {
      key: 'quiz',
      label: 'QUIZ',
      children: <CardsTable type="quiz" />,
    },
    {
      key: 'musicQuiz',
      label: 'MUSUC QUIZ',
      children: <CardsTable type="musicQuiz" />,
    },
    {
      key: 'virus',
      label: 'VIRUS',
      children: <CardsTable type="virus" />,
    },
    {
      key: 'vaccine',
      label: 'VACCINE',
      children: <CardsTable type="vaccine" />,
    },
    {
      key: 'fortune',
      label: 'FORTUNE',
      children: <CardsTable type="fortune" />,
    },
    {
      key: 'trump',
      label: 'TRUMP',
      children: <CardsTable type="trump" />,
    },
    {
      key: 'fail',
      label: 'FAIL',
      children: <CardsTable type="fail" />,
    },
    {
      key: 'truth',
      label: 'TRUTH',
      children: <CardsTable type="truth" />,
    },
    {
      key: 'competition',
      label: 'COMPETITION',
      children: <CardsTable type="competition" />,
    },
    {
      key: 'date',
      label: 'DARE',
      children: <CardsTable type="dare" />,
    },
  ];

  return (
    <Layout logOut={logOut} title={<div>List games cards</div>} loading={loading}>
      <Tabs defaultActiveKey="1" items={items} onChange={onChangeTab} size="large" />
    </Layout>
  );
};

export default GameCardsPage;
